// This file is generated by scripts/generate-build-info.js
// Do not edit manually.

export const buildId = "dpl_8fkzzPYeaGLszRyXYHU8jUoexyE1" as const;
export const builtAt = "2026-11-04T04:20:54.919Z" as const;
export const vercelEnv: string | null = "production";
export const gitCommitSha: string | null = "fe989e50f40231a6aaf5b0d1fd058201cb08f907";
export const deploymentId: string | null = "dpl_8fkzzPYeaGLszRyXYHU8jUoexyE1";
